import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.45)',
  zIndex: 3999,
};

const headerStyle = {
  padding: '16px',
  borderBottom: '1px solid #eee',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

/**
 * Right-side sliding panel with a dimmed, click-to-close overlay and
 * Escape-key handling - the pattern already proven in
 * SubcategoryItemsModal.jsx, generalized for reuse (SHOP-8).
 */
const SlidePanel = ({ isOpen, onClose, title, closeLabel, children, isMobile = false }) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <style>
        {`
          @keyframes slideIn {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
        `}
      </style>

      <div data-testid="slide-panel-overlay" style={overlayStyle} onClick={onClose} />

      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          height: '100%',
          width: isMobile ? '100%' : '85%',
          maxWidth: isMobile ? '100%' : '360px',
          backgroundColor: '#fff',
          zIndex: 4000,
          boxShadow: '-8px 0 20px rgba(0,0,0,0.25)',
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideIn 0.25s ease-out',
        }}
      >
        <div style={headerStyle}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button
            onClick={onClose}
            aria-label={closeLabel}
            style={{
              background: 'none',
              border: 'none',
              padding: '8px',
              cursor: 'pointer',
            }}
          >
            <FiX size={22} />
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto' }}>{children}</div>
      </div>
    </>
  );
};

export default SlidePanel;
